import React from 'react';
import { useTranslation } from 'react-i18next';
import Block from '../Block';
import ShowItem from '../ShowItem';

export const CredentialBlock = ({publisher}) => {
	const { t, i18n } = useTranslation();

  return (
    <Block>
      <ShowItem label={t("publisher.username")} value={publisher.username} />
      <ShowItem label={t("publisher.password")} value={publisher.password} />
      {publisher.credentials.map((creds, idx)=>{
        return(<React.Fragment key={'api_key_' + idx}>
          <ShowItem label={t("creds.api_key")} value={creds.api_key} />
          <ShowItem label={t("creds.secret")} value={creds.secret} />
        </React.Fragment>)
      })
      }
    </Block>
  )
}
